import { NavLink } from "react-router-dom";
import "./BottomNav.css";

function BottomNav() {

  const row1 = [
    { path: "/WellComp", name: "Well Composition" },
    { path: "/nk1", name: "NK-1 Wellhead" },
    { path: "/nk2", name: "NK-2 Wellhead" },
    { path: "/nk3", name: "NK-3 Wellhead" },
    { path: "/H2OInjectionWellhead", name: "H2O Injection" },
    { path: "/GasLiftManifold", name: "Gas Lift" },
    { path: "/TestHeader", name: "Test Header" },
    { path: "/ProductionHeader1", name: "Prod Header-1" },
    { path: "/ProductionHeader2", name: "Prod Header-2" },
    { path: "/PigLauncher", name: "Pig Launcher" },
    { path: "/PigReceiver", name: "Pig Receiver" },
    { path: "/TestSeparator", name: "Test Sep" },
    { path: "/FirstStageSeparator", name: "1st Sep" },
    { path: "/SecondStageSeparator", name: "2nd Sep" },
    { path: "/ThirdStageSeparator", name: "3rd Sep" }
  ];

  const row2 = [
    { path: "/SludgeCatcher", name: "Sludge Catcher" },
    { path: "/CrudeDehyd", name: "Crude Dehyd" },
    { path: "/CrudeExport", name: "Crude Export" },
    { path: "/LPCompSuctDrumA", name: "LP Drum A" },
    { path: "/LPCompSuctDrumB", name: "LP Drum B" },
    { path: "/MPCompSuctDrumA", name: "MP Drum A" },
    { path: "/MPCompSuctDrumB", name: "MP Drum B" },
    { path: "/HPGasInlet", name: "HP Gas" },
    { path: "/HPGasCooler", name: "HP Cooler" },
    { path: "/GasSweetening", name: "Gas Sweet" },
    { path: "/PreDehydCooler", name: "Pre-Dehyd" },
    { path: "/TEGContactor", name: "TEG Cont" },
    { path: "/TEGReboiler", name: "TEG Reboiler" },
    { path: "/GasExportComp", name: "Gas Comp" },
    { path: "/GasExport", name: "Gas Export" },
  ];

  const row3 = [
    { path: "/DeOiler", name: "De-Oiler" },
    { path: "/H2SStripper", name: "H2S Strip" },
    { path: "/SkimPile", name: "Skim Pile" },
    { path: "/SubseaSettlementTank", name: "Subsea Tank" },
    { path: "/OilyWaterTank", name: "Oily Tank" },
    { path: "/WaterTreatment", name: "Water Treat" },
    { path: "/VacuumDearator", name: "Vacuum Deaerator" },
    { path: "/Na2HydroGen", name: "Na2 HydroGen" },
    { path: "/CorrosionInhibition", name: "Corrosion" },
    { path: "/Flare", name: "Flare" }
  ];

  const renderRow = (row) => (
    <div className="nav-row">
      {row.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          {item.name}
        </NavLink>
      ))}
    </div>
  );

  return (
    <div className="bottom-nav">
      {renderRow(row1)}
      {renderRow(row2)}
      {renderRow(row3)}
    </div>
  );
}

export default BottomNav;